<template>
    <div class="table-responsive">
        <table class="table table-hover table-bordered">
            <thead>
                <tr>
                    <th>Reservation</th>
                    <th>Guest</th>
                    <th>Rooms</th>
                    <th>Check-in</th>
                    <th>Check-out</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in tableItems" :key="item.id">
                    <td>{{ item.reservation_no }}</td>
                    <td>
                        <div class="fw-bold">{{ item.guest_name }}</div>
                        <div class="font-small-3">{{ item.phone }}</div>
                    </td>
                    <td>{{ item.rooms }}</td>
                    <td>{{ item.check_in }}</td>
                    <td>{{ item.discharge_date }}</td>
                    <td>
                        <button
                            v-if="canPay(item)"
                            class="btn btn-sm btn-outline-primary me-1"
                            @click="$emit('onPay', item)"
                        >
                            Pay Now
                        </button>
                        <button
                            v-if="canCheckin(item)"
                            class="btn btn-sm btn-success me-1"
                            @click="$emit('onCheckin', item)"
                        >
                            Check-In
                        </button>
                        <button
                            v-if="canEdit(item)"
                            class="btn btn-sm btn-primary me-1"
                            @click="$emit('onEdit', item)"
                        >
                            <i class="fa fa-pencil-alt"></i>
                        </button>
                        <button
                            v-if="canCancel(item)"
                            class="btn btn-sm btn-danger"
                            @click="$emit('onCancel', item)"
                        >
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
                <tr v-if="!tableItems.length">
                    <td colspan="6" class="text-center">No reservation found</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
defineProps({
    tableItems: {
        type: Array,
        default: () => [],
    },
});

defineEmits(['onPay', 'onEdit', 'onCancel', 'onCheckin']);

const nonEditableStatuses = ['cancelled', 'released', 'completed'];

const isPendingCheckout = (item) => {
    if (item.registration_status !== 'checked_in') return false;
    return item.settlement_status === 'settled';
};

const canEdit = (item) => {
    if (nonEditableStatuses.includes(item.registration_status)) return false;
    if (isPendingCheckout(item)) return false;
    return true;
};

const payableStatuses = ['confirmed', 'checked_in'];

const canPay = (item) => {
    if (item.settlement_status === 'settled') return false;
    if (!payableStatuses.includes(item.registration_status)) return false;
    return item.due > 0;
};

const canCancel = (item) => {
    return item.registration_status === 'confirmed';
};

const checkinStatuses = ['confirmed', 'pending'];

const canCheckin = (item) => {
    return checkinStatuses.includes(item.registration_status);
};
</script>
